import EmptyState from '../components/EmptyState';

export default function Dashboard() {
  return (
    <EmptyState
      title="Dashboard"
      description="System overview, generation metrics, and pipeline status"
      phase={1}
    />
  );
}
